import React from 'react';
import { Input, TextArea, DatePicker } from 'components/tt-forms/common';
import { validatable } from 'components/utils';
import { ThanhTra } from 'api';
import moment from 'moment';
import { Toastr } from 'modules/toastr';
import {
  DropDownMulipleUse
} from 'components/tt-forms';
import { Link } from 'react-router';
import { ShowIf, ShowIfCheck } from 'components/utils';
import { Dialog } from '@blueprintjs/core';

class DonDocDoiTuong extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      //bool
      dataDetail: this.props.dataDetail,
      getThoiHanDonDoc: false,
      openDialog: false,
      enableDelete: this.props.enableDelete,

      coQuanBanHanhCuongChe: this.props.coQuanBanHanhCuongChe ? this.props.coQuanBanHanhCuongChe : '',
      coQuanBanHanhHuyCuongChe: this.props.coQuanBanHanhHuyCuongChe ? this.props.coQuanBanHanhHuyCuongChe : '',
      doiTuongViPham: this.props.doiTuongViPham ? this.props.doiTuongViPham : '',
      ghiChu: this.props.ghiChu ? this.props.ghiChu : '',
      hinhThucCuongChe: this.props.hinhThucCuongChe ? this.props.hinhThucCuongChe : '',
      hinhThucDonDoc: this.props.hinhThucDonDoc ? this.props.hinhThucDonDoc : '',
      huyCuongChe: this.props.huyCuongChe ? this.props.huyCuongChe : '',
      id: this.props.donDocDoiTuongId ? this.props.donDocDoiTuongId : '',
      ketQuaThucHien: this.props.ketQuaThucHien ? this.props.ketQuaThucHien : '',
      ngayBanHanh: this.props.ngayBanHanh ? new Date(this.props.ngayBanHanh) : '',
      ngayBanHanhCuongChe: this.props.ngayBanHanhCuongChe ? new Date(this.props.ngayBanHanhCuongChe) : '',
      ngayBanHanhHuyCuongChe: this.props.ngayBanHanhHuyCuongChe ? new Date(this.props.ngayBanHanhHuyCuongChe) : '',
      ngayBatDauDonDoc: this.props.ngayBatDauDonDoc ? new Date(this.props.ngayBatDauDonDoc) : '',
      ngayHetHanDonDoc: this.props.ngayHetHanDonDoc ? moment(this.props.ngayHetHanDonDoc).format('DD/MM/YYYY') : '',
      ngayHetHanDonDocISO: this.props.ngayHetHanDonDoc ? this.props.ngayHetHanDonDoc : '',
      soQuyetDinhCuongChe: this.props.soQuyetDinhCuongChe ? this.props.soQuyetDinhCuongChe : '',
      soQuyetDinhHuyCuongChe: this.props.soQuyetDinhHuyCuongChe ? this.props.soQuyetDinhHuyCuongChe : '',
      soTienCuongChe: this.props.soTienCuongChe ? this.props.soTienCuongChe : '',
      soVanBan: this.props.soVanBan ? this.props.soVanBan : '',
      thoiGianThucHienCuongChe: this.props.thoiGianThucHienCuongChe ? new Date(this.props.thoiGianThucHienCuongChe) : '',
      thoiGianThucHienHuyCuongChe: this.props.thoiGianThucHienHuyCuongChe ? new Date(this.props.thoiGianThucHienHuyCuongChe) : '',
      thoiHanDonDoc: this.props.thoiHanDonDoc ? this.props.thoiHanDonDoc : '',
      thoiHanNgayLamViecDonDoc: this.props.thoiHanNgayLamViecDonDoc ? this.props.thoiHanNgayLamViecDonDoc : '',
      tinhHinhTienDoThucHienCuongChe: this.props.tinhHinhTienDoThucHienCuongChe ? this.props.tinhHinhTienDoThucHienCuongChe : '',
      tinhHinhTienDoThucHienKetLuan: this.props.tinhHinhTienDoThucHienKetLuan ? this.props.tinhHinhTienDoThucHienKetLuan : '',
      toChucTinDungThucHienCuongChe: this.props.toChucTinDungThucHienCuongChe ? this.props.toChucTinDungThucHienCuongChe : '',
      toChucTinDungThucHienHuyCuongChe: this.props.toChucTinDungThucHienHuyCuongChe ? this.props.toChucTinDungThucHienHuyCuongChe : '',

      dataKetQuaThucHienDonDoc: this.props.dataKetQuaThucHienDonDoc,
      dataHinhThucDonDoc: this.props.dataHinhThucDonDoc
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dataKetQuaThucHienDonDoc != this.props.dataKetQuaThucHienDonDoc) {
      this.setState({
        dataKetQuaThucHienDonDoc: nextProps.dataKetQuaThucHienDonDoc
      })
    }
    if (nextProps.dataHinhThucDonDoc != this.props.dataHinhThucDonDoc) {
      this.setState({
        dataHinhThucDonDoc: nextProps.dataHinhThucDonDoc
      })
    }
    if (nextProps.enableDelete != this.props.enableDelete) {
      this.setState({
        enableDelete: nextProps.enableDelete
      })
    }
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    }, () => {
      if (name == 'thoiHanDonDoc') {
        this.getThoiHanDonDoc();
      } else {
        this.pushData()
      }
    })
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      if (name == 'ngayBatDauDonDoc') {
        this.setState({
          [name]: e._d
        }, () => {
          this.getThoiHanDonDoc()
        })
      } else {
        this.setState({
          [name]: e._d
        }, () => {
          this.pushData()
        })
      }
    } else {
      if (name == 'ngayBatDauDonDoc') {
        this.setState({
          [name]: e
        }, () => {
          this.getThoiHanDonDoc()
        })
      } else {
        this.setState({
          [name]: e
        }, () => {
          this.pushData()
        })
      }
    }
  }

  handleCheck(name, e) {
    this.setState({
      [name]: e
    }, () => {
      this.reSetData();
    })
    if (!e) {

    }
  }

  reSetData() {
    this.setState({
      soQuyetDinhHuyCuongChe: '',
      ngayBanHanhHuyCuongChe: '',
      coQuanBanHanhHuyCuongChe: '',
      thoiGianThucHienHuyCuongChe: '',
      toChucTinDungThucHienHuyCuongChe: '',
      ghiChu: '',
    }, () => {
      this.pushData()
    })
  }

  getThoiHanDonDoc() {
    if (this.state.ngayBatDauDonDoc) {
      this.setState({
        getThoiHanDonDoc: true
      })
      let params = {
        thoiHanThanhTra: this.state.thoiHanDonDoc ? Number(this.state.thoiHanDonDoc) : 0,
        ngayCongBoQD: moment(this.state.ngayBatDauDonDoc).add(7, 'hours').toISOString()
      }
      ThanhTra.actions.getThoiHanThanhTra.request('', params).then(res => {
        if (res.data) {
          this.setState({
            ngayHetHanDonDoc: moment(new Date(res.data)).format('DD/MM/YYYY'),
            ngayHetHanDonDocISO: res.data
          }, () => {
            this.setState({
              getThoiHanDonDoc: false
            })
            this.pushData()
          })
        }
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        this.setState({
          getThoiHanDonDoc: false
        })
      });
    } else {
      this.setState({
        ngayHetHanDonDoc: '',
        ngayHetHanDonDocISO: null
      }, () => {
        this.pushData()
      })
    }
  }

  pushData() {
    let item = this.state.dataDetail;
    item.hinhThucDonDoc = this.state.hinhThucDonDoc ? this.state.hinhThucDonDoc : null;
    item.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
    item.ngayBanHanh = this.state.ngayBanHanh ? moment(this.state.ngayBanHanh).toISOString() : null;
    item.ngayBatDauDonDoc = this.state.ngayBatDauDonDoc ? moment(this.state.ngayBatDauDonDoc).toISOString() : null;
    item.thoiHanDonDoc = this.state.thoiHanDonDoc ? this.state.thoiHanDonDoc : '';
    item.tinhHinhTienDoThucHienKetLuan = this.state.tinhHinhTienDoThucHienKetLuan ? this.state.tinhHinhTienDoThucHienKetLuan : '';

    item.ketQuaThucHien = this.state.ketQuaThucHien ? this.state.ketQuaThucHien : null;
    item.thoiHanNgayLamViecDonDoc = this.state.thoiHanNgayLamViecDonDoc ? this.state.thoiHanNgayLamViecDonDoc : '';
    item.ngayHetHanDonDoc = this.state.ngayHetHanDonDocISO ? this.state.ngayHetHanDonDocISO : null;
    item.doiTuongViPham = {
      id: Number(this.props.doiTuongViPhamId)
    }

    if (this.state.id) {
      item.id = this.state.id
    }
    if (this.state.ketQuaThucHien == 'CHUA_THUC_HIEN') {
      item.soQuyetDinhCuongChe = this.state.soQuyetDinhCuongChe ? this.state.soQuyetDinhCuongChe : '';
      item.ngayBanHanhCuongChe = this.state.ngayBanHanhCuongChe ? moment(this.state.ngayBanHanhCuongChe).toISOString() : null;

      item.coQuanBanHanhCuongChe = this.state.coQuanBanHanhCuongChe ? this.state.coQuanBanHanhCuongChe : '';
      item.soTienCuongChe = this.state.soTienCuongChe ? this.state.soTienCuongChe : '';
      item.thoiGianThucHienCuongChe = this.state.thoiGianThucHienCuongChe ? moment(this.state.thoiGianThucHienCuongChe).toISOString() : null;
      item.toChucTinDungThucHienCuongChe = this.state.toChucTinDungThucHienCuongChe ? this.state.toChucTinDungThucHienCuongChe : '';
      item.tinhHinhTienDoThucHienCuongChe = this.state.tinhHinhTienDoThucHienCuongChe ? this.state.tinhHinhTienDoThucHienCuongChe : '';
      item.hinhThucCuongChe = this.state.hinhThucCuongChe ? this.state.hinhThucCuongChe : '';
    } else {
      item.soQuyetDinhCuongChe = '';
      item.ngayBanHanhCuongChe = null;

      item.coQuanBanHanhCuongChe = '';
      item.soTienCuongChe = '';
      item.thoiGianThucHienCuongChe = null;
      item.toChucTinDungThucHienCuongChe = '';
      item.tinhHinhTienDoThucHienCuongChe = '';
      item.hinhThucCuongChe = '';
    }
    if (this.state.huyCuongChe) {
      item.huyCuongChe = true;
      item.soQuyetDinhHuyCuongChe = this.state.soQuyetDinhHuyCuongChe ? this.state.soQuyetDinhHuyCuongChe : '';
      item.ngayBanHanhHuyCuongChe = this.state.ngayBanHanhHuyCuongChe ? moment(this.state.ngayBanHanhHuyCuongChe).toISOString() : null;
      item.coQuanBanHanhHuyCuongChe = this.state.coQuanBanHanhHuyCuongChe ? this.state.coQuanBanHanhHuyCuongChe : '';
      item.thoiGianThucHienHuyCuongChe = this.state.thoiGianThucHienHuyCuongChe ? moment(this.state.thoiGianThucHienHuyCuongChe).toISOString() : null;
      item.toChucTinDungThucHienHuyCuongChe = this.state.toChucTinDungThucHienHuyCuongChe ? this.state.toChucTinDungThucHienHuyCuongChe : '';
      item.ghiChu = this.state.ghiChu ? this.state.ghiChu : '';
    } else {
      item.huyCuongChe = false;
      item.soQuyetDinhHuyCuongChe = '';
      item.ngayBanHanhHuyCuongChe = null;
      item.coQuanBanHanhHuyCuongChe = '';
      item.thoiGianThucHienHuyCuongChe = null;
      item.toChucTinDungThucHienHuyCuongChe = '';
      item.ghiChu = '';
    }

    delete item['_links'];
    delete item['nguoiSuaInfo'];
    delete item['nguoiTaoInfo'];
    delete item['ngaySua'];
    delete item['ngayTao'];

    delete item['hinhThucDonDocInfo'];
    delete item['ketQuaThucHienInfo'];
    delete item['listTaiLieuDonDoc'];
    delete item['donDocDoiTuongId'];

    if (this.state.id) {
      this.props.onChange(item, this.state.id)
    } else {
      this.props.onChange(item, this.props.indexItem)
    }
  }

  onRemove() {
    this.setState({
      openDialog: false
    })
    if (this.state.id) {
      this.props.onRemove(this.props.indexItem, this.state.id)
    } else {
      this.props.onRemove(this.props.indexItem)
    }
  }

  openDialog() {
    this.setState({
      openDialog: true
    })
  }

  closeDialog() {
    this.setState({
      openDialog: false
    })
  }

  render() {
    return (
      <div>
        <ShowIf condition={this.props.countItem <= 1}>
          <div className='justify-content mb15'>
            <h2 className='title-12 mt15'>{`${this.props.toChucLienQuan ? '2' : '3'}.1. Đôn đốc`}</h2>
          </div>
        </ShowIf>
        <ShowIf condition={this.props.countItem > 1}>
          <ShowIf condition={this.props.index > 0}>
            <div className='line-border'></div>
          </ShowIf>
          <div className={`mt15 justify-content mb15`}>
            <h2 className='title-12'>{`${this.props.toChucLienQuan ? '2' : '3'}.${this.props.index + 1}. Lần đôn đốc số ${this.props.index + 1}`}</h2>
            <ShowIf condition={this.state.enableDelete}>
              <Link className='itt-delete' onClick={this.openDialog.bind(this)}>Xóa</Link>
            </ShowIf>
          </div>
        </ShowIf>
        <div className='row pl10 pr10'>
          <DropDownMulipleUse data={this.state.dataHinhThucDonDoc} bindValidator={this} keyName='giaTri' valueName='ten' className='col-25' label='Hình thức đôn đốc' selectedValue={this.state.hinhThucDonDoc} onChange={this.onChange.bind(this, 'hinhThucDonDoc')} name='hinhThucDonDoc' />
          <Input className='col-25' placeholder='Nhập...' bindValidator={this} channel='formTaoDon' label='Số văn bản' value={this.state.soVanBan} onChange={this.onChange.bind(this, 'soVanBan')} name='soVanBan' maxLength={255}/>
          <DatePicker className='col-25' bindValidator={this} channel='formTaoDon' label='Ngày ban hành' value={this.state.ngayBanHanh} onChange={this.handleChangeDate.bind(this, 'ngayBanHanh')} endDate={new Date()} name='ngayBanHanh' />
        </div>

        <div className='row pl10 pr10'>
          <DatePicker label='Ngày bắt đầu' className='col-25' value={this.state.ngayBatDauDonDoc} onChange={this.handleChangeDate.bind(this, 'ngayBatDauDonDoc')} name='ngayBatDauDonDoc' bindValidator={this} channel="formTaoDon" />
          <div className='wrap-thoihan col-25'>
            <Input label='Thời hạn đôn đốc (ngày làm việc)' type='sdt' className='col-100 no-gutter' value={this.state.thoiHanDonDoc} onChange={this.onChange.bind(this, 'thoiHanDonDoc')} name='thoiHanDonDoc' />
            <span className='thoihan-value'>
              <ShowIf condition={!this.state.getThoiHanDonDoc}>
                <span>
                  {this.state.ngayHetHanDonDoc ? this.state.ngayHetHanDonDoc : ''}
                </span>
              </ShowIf>
              <ShowIf condition={this.state.getThoiHanDonDoc}>
                <span className='icon-loader'></span>
              </ShowIf>
            </span>
          </div>
        </div>

        <div className='row pl10 pr10'>
          <TextArea className='col-100' label='Tình hình, tiến độ thực hiện kết luận' placeholder='Nhập...' value={this.state.tinhHinhTienDoThucHienKetLuan} onChange={this.onChange.bind(this, 'tinhHinhTienDoThucHienKetLuan')} name='tinhHinhTienDoThucHienKetLuan' />
        </div>

        <div className='row pl10 pr10'>
          <DropDownMulipleUse data={this.state.dataKetQuaThucHienDonDoc} keyName='giaTri' valueName='ten' className='col-25' label='Kết quả đôn đốc' selectedValue={this.state.ketQuaThucHien} onChange={this.onChange.bind(this, 'ketQuaThucHien')} name='ketQuaThucHien' />
        </div>

        <ShowIf condition={this.state.ketQuaThucHien == 'CHUA_THUC_HIEN'}>
          <div className='row pl10 pr10'>
            <h2 className='col-100 txt-bold txt-upper mb15 text-14'>Cưỡng chế</h2>
            <Input className='col-25' placeholder='Nhập...' bindValidator={this} channel='formTaoDon' require label='Số quyết định cưỡng chế' value={this.state.soQuyetDinhCuongChe} onChange={this.onChange.bind(this, 'soQuyetDinhCuongChe')} name='soQuyetDinhCuongChe' maxLength={255} />
            <DatePicker className='col-25' bindValidator={this} endDate={new Date()} channel='formTaoDon' require label='Ngày ban hành' value={this.state.ngayBanHanhCuongChe} onChange={this.handleChangeDate.bind(this, 'ngayBanHanhCuongChe')} name='ngayBanHanhCuongChe' />
            <Input className='col-25' placeholder='Nhập...' label='Cơ quan ban hành' value={this.state.coQuanBanHanhCuongChe} onChange={this.onChange.bind(this, 'coQuanBanHanhCuongChe')} name='coQuanBanHanhCuongChe' />
            <Input className='col-25' type='sdt' align='right' placeholder='Nhập...' label='Số tiền (đ)' value={this.state.soTienCuongChe} onChange={this.onChange.bind(this, 'soTienCuongChe')} name='soTienCuongChe' />
          </div>
          <div className='row pl10 pr10'>
            <DatePicker className='col-25' label='Thời gian thực hiện' value={this.state.thoiGianThucHienCuongChe} onChange={this.handleChangeDate.bind(this, 'thoiGianThucHienCuongChe')} name='thoiGianThucHienCuongChe' />
            <Input className='col-25' placeholder='Nhập...' label='Tổ chức tín dụng thực hiện' value={this.state.toChucTinDungThucHienCuongChe} onChange={this.onChange.bind(this, 'toChucTinDungThucHienCuongChe')} name='toChucTinDungThucHienCuongChe' />
            <Input className='col-25' placeholder='Nhập...' label='Tình hình tiến độ thực hiện' value={this.state.tinhHinhTienDoThucHienCuongChe} onChange={this.onChange.bind(this, 'tinhHinhTienDoThucHienCuongChe')} name='tinhHinhTienDoThucHienCuongChe' />
            <Input className='col-25' placeholder='Nhập...' label='Hình thức cưỡng chế' value={this.state.hinhThucCuongChe} onChange={this.onChange.bind(this, 'hinhThucCuongChe')} name='hinhThucCuongChe' />
          </div>

          <div className='row pl15 pr15'>
            <ShowIfCheck titleClass='txt-black txt-bold txt-upper mb10 text-14 lable-title-custom' className='row pl15 pr15' label='Hủy cưỡng chế' onChange={this.handleCheck.bind(this, 'huyCuongChe')} name='huyCuongChe' checked={this.state.huyCuongChe}>
              <div className='row pl10 pr10'>
                <Input className='col-25' placeholder='Nhập...' bindValidator={this} channel='formTaoDon' require label='Số quyết định hủy cưỡng chế' value={this.state.soQuyetDinhHuyCuongChe} onChange={this.onChange.bind(this, 'soQuyetDinhHuyCuongChe')} name='soQuyetDinhHuyCuongChe' maxLength={255} />
                <DatePicker className='col-25' bindValidator={this} channel='formTaoDon' endDate={new Date()} require label='Ngày ban hành' value={this.state.ngayBanHanhHuyCuongChe} onChange={this.handleChangeDate.bind(this, 'ngayBanHanhHuyCuongChe')} name='ngayBanHanhHuyCuongChe' />
                <Input className='col-25' placeholder='Nhập...' label='Cơ quan ban hành' value={this.state.coQuanBanHanhHuyCuongChe} onChange={this.onChange.bind(this, 'coQuanBanHanhHuyCuongChe')} name='coQuanBanHanhHuyCuongChe' />
              </div>
              <div className='row pl10 pr10'>
                <DatePicker className='col-25' label='Thời gian thực hiện' value={this.state.thoiGianThucHienHuyCuongChe} onChange={this.handleChangeDate.bind(this, 'thoiGianThucHienHuyCuongChe')} name='thoiGianThucHienHuyCuongChe' />
                <Input className='col-25' placeholder='Nhập...' label='Tổ chức tín dụng thực hiện' value={this.state.toChucTinDungThucHienHuyCuongChe} onChange={this.onChange.bind(this, 'toChucTinDungThucHienHuyCuongChe')} name='toChucTinDungThucHienHuyCuongChe' />
              </div>
              <div className='row pl10 pr10'>
                <TextArea className='col-100' label='Ghi chú' placeholder='Nhập...' value={this.state.ghiChu} onChange={this.onChange.bind(this, 'ghiChu')} name='ghiChu' maxLength={1000} />
              </div>
            </ShowIfCheck>
          </div>
        </ShowIf>
        <Dialog
          isOpen={this.state.openDialog}
          onClose={this.closeDialog.bind(this)}
          title='Xác nhận'
          className="reception-dialog delete-dialog wrap-block"
        >
          <div className="pt-dialog-body mb0">
            <p className='pt10 pb20 txt-center'>Bạn có muốn xóa lần đôn đốc này?</p>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.closeDialog.bind(this)}><span>Không</span></Link>
            <Link className="btn-action btn-green action-todo" onClick={this.onRemove.bind(this)}><span>Đồng ý</span></Link>
          </div>
        </Dialog>
      </div>
    )
  }
}

DonDocDoiTuong.defaultProps = {
  validators: {
    formTaoDon: []
  },
  enableDelete: false,
  dataDetail: []
}

export default validatable(DonDocDoiTuong);



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/DonDocDoiTuong.jsx